import { isPlainObject } from 'lodash/lang';
import { get, merge, setWith } from 'lodash/object';

export function setIn(obj, path, value, shouldMerge = false) {
  if (!path) {
    return obj;
  }
  return setWith({ ...obj }, path, calculateFinalValue(), objValue => {
    if (objValue && typeof objValue === 'object') {
      return Array.isArray(objValue) ? [...objValue] : { ...objValue };
    }
    return objValue;
  });

  function calculateFinalValue() {
    if (shouldMerge && isPlainObject(value)) {
      const existingValue = get(obj, path);
      if (isPlainObject(existingValue)) {
        return merge({}, existingValue, value);
      }
    }
    return value;
  }
}
